import { render, staticRenderFns } from "./CreateTestCollectionOrderDialog.vue?vue&type=template&id=3bfbf52f&"
import script from "./CreateTestCollectionOrderDialog.vue?vue&type=script&lang=js&"
export * from "./CreateTestCollectionOrderDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports